import { render } from "./PageDataPengaduan.vue?vue&type=template&id=0d07907b&scoped=true"
import script from "./PageDataPengaduan.vue?vue&type=script&lang=js"
export * from "./PageDataPengaduan.vue?vue&type=script&lang=js"

import "./PageDataPengaduan.vue?vue&type=style&index=0&id=0d07907b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d07907b"]])

export default __exports__